import { useEffect } from 'react';
import { connect } from 'react-redux';
import { AvailableMedicalService } from '../../../models/Entities/MedicalServices/AvailableMedicalService';
import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { Label, MessageBarBody, Spinner, Switch, Text } from '@fluentui/react-components';
import { GuideDrawer } from '../../../theme/components/GuideDrawer';
import { GuideMessageBar } from '../../../theme/components/GuideMessageBar';

// Store
import * as MedicalServiceStore from '../../../redux/middleware/MedicalServicesMiddleware';

////i18Next
import { useTranslation } from 'react-i18next';

//styles
import './MedicalServiceMultiSelectorComponent.css';

export type SelectedMedicalServiceType = {
  medicalServiceId: number;
  ReferenceId: number;
};

export interface IProps {
  isOpen: boolean;
  openPanel: () => void;
  dismissPanel: () => void;
  SelectedServices: SelectedMedicalServiceType[];
  ViewOnly3erPartyServices: boolean | undefined;
  ErrorInformed: ErrorType | undefined;
  onSelect?: (service: AvailableMedicalService) => void;
  onUnselect?: (service: SelectedMedicalServiceType) => void;
}

interface ConnectedProps {
  isLoading: boolean;
  loadingSuccess: boolean;
  failOnLoading: boolean;
  error: ErrorType;
  MedicalServices: AvailableMedicalService[];
}

interface DispatchProps {
  GetAllMedicalServices: typeof MedicalServiceStore.actionCreators.GetAllMedicalServices;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const MedicalServiceMultiSelectorComponent = ({
  MedicalServices,
  isLoading,
  failOnLoading,
  ErrorInformed,
  error,
  SelectedServices,
  isOpen,
  ViewOnly3erPartyServices,
  openPanel: _openPanel,
  dismissPanel,
  onSelect,
  onUnselect,
  GetAllMedicalServices
}: Props) => {

  //useTranslation();
  const [t] = useTranslation();

  useEffect(() => {
    if (GetAllMedicalServices) GetAllMedicalServices(1, 200, undefined);
  }, [GetAllMedicalServices]);

  const HandleCancelForm = () => {
    dismissPanel();
  };

  const OnSelectService = (service: AvailableMedicalService) => {
    if (onSelect) onSelect(service);
  };
  const OnUnselectService = (
    service: SelectedMedicalServiceType | undefined
  ) => {
    if (onUnselect && service) onUnselect(service);
  };

  const optionList = (
    <div className="MedicalServiceMultiSelectorContent">
      {ViewOnly3erPartyServices && (
        <GuideMessageBar intent="info">
          <MessageBarBody>
            {t('medicalServiceMultiselector.message.enableMedicalService')}
          </MessageBarBody>
        </GuideMessageBar>
      )}
      <GuideMessageBar intent="warning">
        <MessageBarBody>
          {t('medicalServiceMultiselector.message.medicalService')}
          &nbsp;{SelectedServices.length}&nbsp;
          {t('medicalServiceMultiselector.message.selectedMedicalService')}
        </MessageBarBody>
      </GuideMessageBar>
      {ErrorInformed && (
        <GuideMessageBar intent="error">
          <MessageBarBody>{ErrorInformed.ErrorMessage}</MessageBarBody>
        </GuideMessageBar>
      )}
      <div className="SelectionMSListContainer">
        <div className="SelectionListRows">
          {MedicalServices &&
            MedicalServices.map((medicalService: AvailableMedicalService) => (
              <div key={medicalService.id} className="SelectionListRow">
                <div className="SelectionList">
                  <Switch
                    checked={
                      SelectedServices.find(
                        (service: SelectedMedicalServiceType) =>
                          service.medicalServiceId === medicalService.id
                      )
                        ? true
                        : false
                    }
                    onChange={(_, data) =>
                      data.checked
                        ? OnSelectService(medicalService)
                        : OnUnselectService(
                            SelectedServices.find(
                              (service: SelectedMedicalServiceType) =>
                                service.medicalServiceId === medicalService.id
                            )
                          )
                    }
                  />
                  <div className="SelectionList-item">
                    <Label weight="semibold">
                      {medicalService.serviceNameReference}
                    </Label>
                    {medicalService.available ? (
                      <Text>{medicalService.comments}</Text>
                    ) : (
                      <Text style={{ color: 'var(--ichtys-error)' }}>{t('medicalServiceMultiselector.selectionList.disabled')}</Text>
                    )}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );

  return (
    <GuideDrawer
      open={isOpen}
      size="large"
      title={t('medicalServiceMultiselector.modal.medicalService')}
      onDismiss={HandleCancelForm}
      testId="medical-service-multi-selector-drawer"
      secondaryAction={{ label: t('medicalServiceMultiselector.footer.closeButton'), testId: 'medical-service-multi-selector-drawer-close' }}
    >
      {failOnLoading && (
        <GuideMessageBar intent="error">
          <MessageBarBody>{error?.ErrorMessage}</MessageBarBody>
        </GuideMessageBar>
      )}

      {isLoading ? (
        <Spinner label={t('medicalServiceMultiselector.loading.medicalServices')} />
      ) : (
        optionList
      )}
    </GuideDrawer>
  );
};

const mapStateToProps = (state: AppState, ownprops: IProps) => ({
  isLoading: state.MedicalServices?.isLoadingAll,
  loadingSuccess: state.MedicalServices?.successLoadingAll,
  failOnLoading: state.MedicalServices?.failOnLoadingAll,
  error: state.MedicalServices?.error,
  MedicalServices:
    ownprops.ViewOnly3erPartyServices === undefined
      ? state.MedicalServices?.list
      : state.MedicalServices?.list.filter(
          (service: AvailableMedicalService) =>
            service.serviceProvidedBy3rdParty ===
            ownprops.ViewOnly3erPartyServices
        )
});

const mapDispatchToProps = {
  ...MedicalServiceStore.actionCreators
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MedicalServiceMultiSelectorComponent as any);
